export default {"src":"/_next/static/media/crystal_svg_text_logo.3135d5f3.svg","height":85,"width":344,"blurWidth":0,"blurHeight":0};